import * as React from "react";
import { Card } from "antd";
import { CardTitle } from "../../../../components/antd/card/CardTitle";
import { CardContent } from "../../../../components/antd/card/CardContent";
import { useCpFormValue } from "../../../gvc/testNewForm/utils";
import { CpFormItem } from "../../../gvc/testNewForm/CpFormItem";
import { CpLabel } from "../../../gvc/testNewForm/CpLabel";
import { useCanRenderAdvanced } from "./useCanRenderAdvanced";
import { CpErrorWarning } from "../../../gvc/testNewForm/CpErrorWarning";
import { CpErrorWarningArrayIcon } from "../../../gvc/testNewForm/CpErrorWarningArrayIcon";
import { CpKindSelect } from "../../../gvc/testNewForm/temp/CpKindSelect";

interface Props {}
export const GvcSubdomain: React.FC<Props> = ({}) => {
  const canRender = useCanRenderAdvanced();
  const routingMode = useCpFormValue("advanced.spec.routingMode") || "";

  if (routingMode !== "gvcSubdomain" || !canRender) {
    return null;
  }

  return (
    <div className="cpln-form-section cpln-ant-card-container" data-section-id={"gvc"}>
      <Card>
        <CardTitle>
          GVC Subdomain Routing
          <CpErrorWarningArrayIcon names={[`gvc`]} />
        </CardTitle>
        <CardContent>
          <CpFormItem>
            <CpLabel name="gvc">GVC Selection</CpLabel>
          </CpFormItem>
          <CpKindSelect name="gvc" kind="gvc" optionValue="name" style={{ maxWidth: 600 }} />
          <CpErrorWarning name="gvc" />
        </CardContent>
      </Card>
    </div>
  );
};
